/**
 * アクティビティで呼び出す可能性のあるheliport APIのラッパーを提供
 * アクティビティから直接APIを呼び出すことは後方互換性の観点から禁止されている
 */

Object.assign(globalThis, {
  /**
   * intermediateEcApi
   * EC連携アクティビティから参照
   */
  hel_api_ec_initialize: () => {
    globalThis.heliport.v3.api.intermediateEcApi.initialize();
  },

  hel_api_ec_getProduct: async (id: number) => {
    const res = await globalThis.heliport.v3.api.intermediateEcApi.getProduct(id);
    return res.data;
  },

  hel_api_ec_getProducts: async (storeId: number) => {
    const res = await globalThis.heliport.v3.api.intermediateEcApi.getProducts(storeId);
    return res.data;
  },

  hel_api_ec_getProductByLabel: async (storeId: number, label: string) => {
    const res = await globalThis.heliport.v3.api.intermediateEcApi.getProductByLabel(
      storeId,
      label
    );
    return res.data;
  },

  hel_api_ec_getProductVariantByLabel: async (storeId: number, label: string) => {
    const res = await globalThis.heliport.v3.api.intermediateEcApi.getProductVariantByLabel(
      storeId,
      label
    );
    return res.data;
  },

  /**
   * license
   * EC連携アクティビティから参照
   */
  hel_api_license_getEcs: async (worldId: string) => {
    const res = await globalThis.heliport.v3.api.license.getEcs(worldId);
    return JSON.stringify(res.data);
  },

  /**
   * parads
   * ParadNPCアクティビティから参照
   */
  hel_api_parads_fetchParadListForce: async (params: Record<string, string>) => {
    const res = await globalThis.heliport.v3.api.parads.fetchParadListForce(params);
    return JSON.stringify(res.data);
  },

  /**
   * analytics
   * ParadNPCアクティビティから参照
   */
  hel_api_analytics_setAnalyticsParad: (event: string, params: string) => {
    globalThis.heliport.v3.api.analytics.setAnalyticsParad(event, JSON.parse(params));
  },

  /**
   * spaceChat
   * 空間チャットアクティビティから参照
   */
  hel_api_spaceChat_watchSpaceChatNotification: (params: any) => {
    const spatiumCode = params.spatiumCode;
    const worldId = params.worldId;
    globalThis.heliport.v3.api.spaceChat.watchSpaceChatNotification(spatiumCode, worldId);
  },

  hel_api_spaceChat_unWatchSpaceChatNotification: () => {
    globalThis.heliport.v3.api.spaceChat.unWatchSpaceChatNotification();
  },

  hel_api_spaceChat_checkIsOutOfDate: (params: any) => {
    const res = globalThis.heliport.v3.api.spaceChat.checkIsOutOfDate(params.dateParam);
    return res;
  },

  hel_api_spaceChat_getNextDateDiff: (params: any) => {
    const res = globalThis.heliport.v3.api.spaceChat.getNextDateDiff(
      params.year,
      params.month,
      params.day,
      params.hour,
      params.minute,
      params.second
    );
    return res;
  },

  hel_api_spaceChat_getAddedChat: () => {
    const res = globalThis.heliport.v3.api.spaceChat.getAddedChat();
    return res;
  },

  hel_api_spaceChat_getTextChatList: async (params: any) => {
    const spatiumCode = params.spatiumCode;
    const worldId = params.worldId;
    const maxLimit = params.maxLimit;

    const res = await globalThis.heliport.v3.api.spaceChat.getTextChatList(
      spatiumCode,
      worldId,
      maxLimit
    );
    return res;
  }
});
